import Vue from "vue";

export const maskT = Vue.directive("maskT", {
  bind(el: any, binding) {
    var value = el.value;
    Object.defineProperty(el, "value", {
      get: function() {
        return value;
      },
      set: function(newValue) {
        el.setAttribute("value", newValue);
      },
      configurable: true
    });
  }
});

export default { maskT };
